<template>
  <AppHeaderLayout>
    <div class="page">
      <header class="page-header">
        <h1>Mobile 管理</h1>
        <button class="btn primary" type="button" @click="openCreate">新增 Mobile</button>
      </header>

      <div class="table-card">
        <div class="search-bar">
          <label class="form-field">
            <span>搜尋</span>
            <input v-model="search.keyword" type="text" placeholder="搜尋 Mobile ID、用途名稱或 Access ID" />
          </label>
        </div>
        <table>
          <thead>
            <tr>
              <th>Mobile ID</th>
              <th>用途名稱</th>
              <th>Access ID</th>
              <th>啟用</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredMobiles" :key="item.id">
              <td>{{ item.mobileId }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.accessId || "-" }}</td>
              <td>
                <label class="switch">
                  <input
                    type="checkbox"
                    :checked="item.active"
                    :disabled="isUpdatingEnableId === item.id"
                    @change="toggleActive(item)"
                  />
                  <span class="slider"></span>
                </label>
              </td>
              <td>
                <button class="link-button" type="button" @click="startEdit(item)">編輯</button>
              </td>
            </tr>
            <tr v-if="isLoading">
              <td colspan="5" class="empty">資料載入中...</td>
            </tr>
            <tr v-else-if="errorMessage">
              <td colspan="5" class="empty">{{ errorMessage }}</td>
            </tr>
            <tr v-else-if="filteredMobiles.length === 0">
              <td colspan="5" class="empty">無資料</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="table-footer">
        <div class="page-size">
          <span>每頁顯示</span>
          <select v-model.number="pageSize">
            <option v-for="size in pageSizes" :key="size" :value="size">{{ size }}</option>
          </select>
          <span>筆</span>
          <span>共 {{ totalCount }} 筆</span>
        </div>

        <div class="pager">
          <button type="button" :disabled="!canPrev || isLoading" @click="prevPage" aria-label="上一頁">
            &lt;
          </button>
          <span>{{ currentPage }} / {{ totalPages }}</span>
          <button type="button" :disabled="!canNext || isLoading" @click="nextPage" aria-label="下一頁">
            &gt;
          </button>
        </div>
      </div>
    </div>

    <div v-if="showModal" class="modal-backdrop">
      <div class="modal">
        <div class="modal-header">
          <h2>{{ modalTitle }}</h2>
          <button class="modal-close" type="button" @click="closeModal">x</button>
        </div>
        <div class="modal-body">
          <div class="form-grid">
            <label class="form-field">
              <span>Mobile ID</span>
              <input v-model="form.mobileId" type="text" placeholder="請輸入 Mobile ID" />
            </label>
            <label class="form-field">
              <span>用途名稱</span>
              <input v-model="form.name" type="text" placeholder="請輸入用途名稱" />
            </label>
            <label class="form-field">
              <span>Access ID</span>
              <input v-model="form.accessId" type="text" placeholder="請輸入 Access ID" />
            </label>
            <label class="form-field">
              <span>密碼</span>
              <input
                v-model="form.pwd"
                type="password"
                :placeholder="editingId === null ? '請輸入密碼' : '請重新輸入密碼'"
              />
            </label>
          </div>
          <div v-if="formError" class="form-error">{{ formError }}</div>
        </div>
        <div class="modal-footer">
          <div class="modal-actions">
            <button class="btn primary" type="button" :disabled="isSubmitting" @click="submitForm">
              {{ isSubmitting ? "處理中..." : submitLabel }}
            </button>
            <button class="btn ghost" type="button" :disabled="isSubmitting" @click="closeModal">取消</button>
          </div>
        </div>
      </div>
    </div>
  </AppHeaderLayout>
</template>

<script>
import AppHeaderLayout from "@/components/AppHeaderLayout.vue";
import {
  ADD_MOBILE,
  GET_ALL_MOBILE,
  MODIFY_MOBILE_BY_ID,
  UPDATE_MOBLIE_ENABLE
} from "@/utils/requestUrl";
import { getToken } from "@/utils/sessionStoraggeUtil";

export default {
  name: "MobileManageView",
  components: {
    AppHeaderLayout
  },
  data() {
    return {
      mobiles: [],
      form: {
        mobileId: "",
        name: "",
        accessId: "",
        pwd: ""
      },
      search: {
        keyword: ""
      },
      showModal: false,
      editingId: null,
      pageSize: 10,
      pageSizes: [10, 50, 100],
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      isLoading: false,
      isSubmitting: false,
      isUpdatingEnableId: null,
      errorMessage: "",
      formError: ""
    };
  },
  computed: {
    submitLabel() {
      return this.editingId === null ? "新增" : "儲存";
    },
    modalTitle() {
      return this.editingId === null ? "新增 Mobile" : "編輯 Mobile";
    },
    filteredMobiles() {
      const keyword = this.search.keyword.trim().toLowerCase();
      return this.mobiles.filter((item) => {
        if (!keyword) {
          return true;
        }
        return (
          (item.mobileId || "").toLowerCase().includes(keyword) ||
          (item.name || "").toLowerCase().includes(keyword) ||
          (item.accessId || "").toLowerCase().includes(keyword)
        );
      });
    },
    canPrev() {
      return this.currentPage > 1;
    },
    canNext() {
      return this.currentPage < this.totalPages;
    }
  },
  watch: {
    pageSize() {
      this.currentPage = 1;
      this.fetchMobiles();
    }
  },
  created() {
    this.fetchMobiles();
  },
  methods: {
    getApiBase() {
      if (window._env_ && window._env_.VUE_APP_REQUEST_DOMAIN) {
        return window._env_.VUE_APP_REQUEST_DOMAIN;
      }
      return "";
    },
    buildHeaders() {
      const headers = {
        "Content-Type": "application/json"
      };
      const token = getToken();
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }
      return headers;
    },
    getUserMemberId() {
      const userInfo = this.$store.getters.getUserInfo || {};
      return userInfo.memberId || userInfo.MemberId || "";
    },
    mapMobile(item) {
      return {
        id: Number(item.id ?? item.Id ?? 0),
        mobileId: item.mobileId || item.MobileId || "",
        name: item.name || item.Name || "",
        accessId: item.accessId || item.AccessId || "",
        active: Boolean(item.enable ?? item.Enable ?? false)
      };
    },
    async fetchMobiles() {
      this.isLoading = true;
      this.errorMessage = "";
      try {
        const response = await fetch(this.getApiBase() + GET_ALL_MOBILE, {
          method: "POST",
          headers: this.buildHeaders(),
          body: JSON.stringify({
            PageIndex: this.currentPage,
            PageSize: this.pageSize
          })
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        if (!response.ok) {
          throw new Error((payload && payload.message) || "取得 Mobile 失敗");
        }

        if (payload && payload.status === "failure") {
          throw new Error(payload.message || "取得 Mobile 失敗");
        }

        const data = (payload && payload.data) || {};
        const list = data.mobileList || data.MobileList || [];
        const totalCount = Number(data.totalCount ?? data.TotalCount ?? 0);
        const totalPages = Number(data.totalPages ?? data.TotalPages ?? 0);

        this.mobiles = list.map(this.mapMobile);
        this.totalCount = totalCount;
        this.totalPages = totalPages > 0 ? totalPages : 1;

        if (this.currentPage > this.totalPages) {
          this.currentPage = this.totalPages;
          await this.fetchMobiles();
        }
      } catch (error) {
        this.mobiles = [];
        this.totalCount = 0;
        this.totalPages = 1;
        this.errorMessage = error.message || "取得 Mobile 失敗";
      } finally {
        this.isLoading = false;
      }
    },
    openCreate() {
      this.resetForm();
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.resetForm();
    },
    async submitForm() {
      this.formError = "";
      if (!this.form.mobileId || !this.form.name || !this.form.accessId || !this.form.pwd) {
        this.formError = "請輸入 Mobile ID、用途名稱、Access ID 與密碼";
        return;
      }

      const memberId = this.getUserMemberId();
      if (!memberId) {
        this.formError = "取得使用者資訊失敗，請重新登入";
        return;
      }

      this.isSubmitting = true;
      try {
        const isCreate = this.editingId === null;
        const url = isCreate ? ADD_MOBILE : MODIFY_MOBILE_BY_ID;
        const body = isCreate
          ? {
              MobileId: this.form.mobileId,
              Name: this.form.name,
              AccessId: this.form.accessId,
              Pwd: this.form.pwd,
              Creator: memberId
            }
          : {
              Id: this.editingId,
              MobileId: this.form.mobileId,
              Name: this.form.name,
              AccessId: this.form.accessId,
              Pwd: this.form.pwd,
              Updator: memberId
            };

        const response = await fetch(this.getApiBase() + url, {
          method: "POST",
          headers: this.buildHeaders(),
          body: JSON.stringify(body)
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        if (!response.ok) {
          throw new Error((payload && payload.message) || "儲存 Mobile 失敗");
        }

        if (payload && payload.status === "failure") {
          throw new Error(payload.message || "儲存 Mobile 失敗");
        }

        this.closeModal();
        if (isCreate) {
          this.currentPage = 1;
        }
        await this.fetchMobiles();
      } catch (error) {
        this.formError = error.message || "儲存 Mobile 失敗";
      } finally {
        this.isSubmitting = false;
      }
    },
    startEdit(item) {
      this.editingId = item.id;
      this.form.mobileId = item.mobileId;
      this.form.name = item.name;
      this.form.accessId = item.accessId || "";
      this.form.pwd = "";
      this.formError = "";
      this.showModal = true;
    },
    resetForm() {
      this.editingId = null;
      this.form.mobileId = "";
      this.form.name = "";
      this.form.accessId = "";
      this.form.pwd = "";
      this.formError = "";
    },
    async toggleActive(item) {
      const memberId = this.getUserMemberId();
      if (!memberId) {
        this.errorMessage = "取得使用者資訊失敗，請重新登入";
        return;
      }

      const newEnable = !item.active;
      this.isUpdatingEnableId = item.id;
      try {
        const response = await fetch(this.getApiBase() + UPDATE_MOBLIE_ENABLE, {
          method: "POST",
          headers: this.buildHeaders(),
          body: JSON.stringify({
            Id: item.id,
            Enable: newEnable,
            Updator: memberId
          })
        });

        let payload = null;
        try {
          payload = await response.json();
        } catch (error) {
          payload = null;
        }

        if (!response.ok) {
          throw new Error((payload && payload.message) || "更新啟用狀態失敗");
        }

        if (payload && payload.status === "failure") {
          throw new Error(payload.message || "更新啟用狀態失敗");
        }

        item.active = newEnable;
      } catch (error) {
        this.errorMessage = error.message || "更新啟用狀態失敗";
      } finally {
        this.isUpdatingEnableId = null;
      }
    },
    async prevPage() {
      if (this.canPrev) {
        this.currentPage -= 1;
        await this.fetchMobiles();
      }
    },
    async nextPage() {
      if (this.canNext) {
        this.currentPage += 1;
        await this.fetchMobiles();
      }
    }
  }
};
</script>

<style scoped>
.page {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 12px 24px rgba(15, 30, 40, 0.08);
  font-size: 1rem;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.page-header h1 {
  margin: 0;
  font-size: 1.625rem;
}

.btn {
  min-width: 90px;
  height: 36px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  font-size: 0.9375rem;
}

.btn.primary {
  background: #0aa0a5;
  color: #ffffff;
}

.btn.ghost {
  background: #eef2f4;
  color: #1f2a33;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.table-card {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(15, 30, 40, 0.08);
}

.search-bar {
  padding: 16px;
  border-bottom: 1px solid rgba(15, 30, 40, 0.08);
  background: #ffffff;
}

.table-card table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.9375rem;
}

.table-card thead {
  background: #f4f7f8;
  text-align: left;
}

.table-card th,
.table-card td {
  padding: 12px 16px;
  border-bottom: 1px solid rgba(15, 30, 40, 0.08);
}

.table-card tbody tr:hover {
  background: rgba(10, 160, 165, 0.06);
}

.link-button {
  border: none;
  background: transparent;
  color: #0aa0a5;
  cursor: pointer;
  padding: 0;
  font-size: 0.9375rem;
}

.link-button:hover {
  text-decoration: underline;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: #d1d6d9;
  transition: 0.2s;
  border-radius: 999px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 2px;
  top: 2px;
  background-color: white;
  transition: 0.2s;
  border-radius: 50%;
}

.switch input:checked + .slider {
  background-color: #0aa0a5;
}

.switch input:checked + .slider:before {
  transform: translateX(18px);
}

.empty {
  text-align: center;
  padding: 24px 0;
  color: rgba(31, 42, 51, 0.5);
}

.table-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 18px;
  gap: 16px;
  flex-wrap: wrap;
}

.page-size {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9375rem;
}

.page-size select {
  border-radius: 8px;
  border: 1px solid rgba(15, 30, 40, 0.2);
  padding: 4px 8px;
  font-size: 0.9375rem;
}

.pager {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9375rem;
}

.pager button {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid rgba(15, 30, 40, 0.2);
  background: #ffffff;
  cursor: pointer;
}

.pager button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 16, 20, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.modal {
  width: min(520px, 92vw);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 24px 48px rgba(15, 30, 40, 0.2);
  padding: 20px 22px 18px;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.modal-header h2 {
  margin: 0;
  font-size: 1.375rem;
}

.modal-close {
  border: none;
  background: transparent;
  font-size: 1.625rem;
  cursor: pointer;
  line-height: 1;
}

.modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.modal-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
  flex-wrap: wrap;
}

.modal-actions {
  display: flex;
  gap: 10px;
}

.form-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  font-size: 0.9375rem;
}

.form-field input {
  height: 38px;
  border-radius: 10px;
  border: 1px solid rgba(20, 40, 50, 0.2);
  padding: 0 12px;
  font-size: 0.9375rem;
}

.form-field input:focus {
  outline: none;
  border-color: rgba(10, 160, 165, 0.7);
  box-shadow: 0 0 0 3px rgba(10, 160, 165, 0.15);
}

.form-error {
  color: #b91c1c;
  font-size: 0.875rem;
}

@media (max-width: 720px) {
  .page {
    padding: 20px;
  }

  .table-footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
